// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

const DISCLAIMER_CONTENT = (
  <div>
    <h1 style={{ textAlign: 'center', margin: '20px 0' }}><u>PUNDIT TOOL</u></h1>


<h2><u>AUTHORIZED USE AND ACKNOWLEDGMENT</u></h2>
<p>Pundit is an AI-powered analytical tool designed 
  exclusively for user research and requirements gathering purposes solely 
  for interviews of internal Amazon employees. By using this Tool, 
  you explicitly acknowledge, agree to, 
  and will strictly adhere to the following terms and conditions:</p>

<div style={{ fontSize: '1.1em', marginTop: '10px' }}>1. AUTHORIZED USE:</div>
<p>The Tool is strictly limited to recording and analyzing:</p>
<ul>
    <li>User research interviews of Amazon employees</li>
    <li>Subject Matter Expert (SME) consultations</li>
    <li>Requirements gathering sessions</li>
    <li>Product research discussions</li>
</ul>
<p>Any use outside these specific purposes is expressly prohibited.</p>

<div style={{ fontSize: '1.1em', marginTop: '10px' }}>2. PROHIBITED USE:</div>
<ul>
    <li>Recording of any other types of meetings, conversations, 
      or communications is strictly forbidden.</li>
    <li>Recording of any meetings, conversations or 
      communications with outside third parties is strictly forbidden.</li>
    <li>The Tool may not be used for surveillance, 
      personal conversations, or general business meetings.</li>
    <li>Any unauthorized use will result in immediate termination of 
      access to the Tool, and may lead to disciplinary action.</li>
</ul>

<div style={{ fontSize: '1.1em', marginTop: '10px' }}>3. DATA PROCESSING AND PRIVACY:</div>
<ul>
    <li>Users must obtain explicit, documented consent from all 
      participants before recording and/or transcribing any session.</li>
    <li>All data processing must comply with applicable privacy 
      laws and regulations.</li>
</ul>

<div style={{ fontSize: '1.1em', marginTop: '10px' }}>4. ACCURACY AND LIMITATIONS:</div>
<ul>
    <li>Users acknowledge that AI-generated transcriptions and summaries may contain errors.</li>
    <li>Users agree to review and verify all AI-generated content for accuracy before use.</li>
    <li>The Tool does not replace human judgment or interpretation.</li>
</ul>

<div style={{ fontSize: '1.1em', marginTop: '10px' }}>5. CONFIDENTIALITY:</div>
<ul>
    <li>All recorded sessions and generated content are subject to
      Amazon&apos;s confidentiality policies.</li>
    <li>Data will be automatically deleted after two years.</li>
    <li>Users are responsible for adhering to all applicable 
      confidentiality agreements, policies, and applicable law.</li>
</ul>

<p>Amazon reserves the right to monitor the Tool usage for 
  compliance with these terms. By using this Tool, you confirm that 
  you have read, understood, and agreed to these terms and conditions.</p></div>
);

export default DISCLAIMER_CONTENT;